import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { updateClinicSettings } from '../../store/settingsSlice'

export function DefaultUnits() {
  const dispatch = useAppDispatch()
  const clinic = useAppSelector((s) => s.settings.clinic)

  const weightUnit = clinic?.weight_unit || 'lbs'
  const temperatureUnit = clinic?.temperature_unit || 'F'

  const toggleWeight = (unit: 'lbs' | 'kg') => {
    if (!clinic || unit === weightUnit) return
    dispatch(
      updateClinicSettings({
        ...clinic,
        weight_unit: unit,
      })
    )
  }

  const toggleTemperature = (unit: 'F' | 'C') => {
    if (!clinic || unit === temperatureUnit) return
    dispatch(
      updateClinicSettings({
        ...clinic,
        temperature_unit: unit,
      })
    )
  }

  return (
    <section data-testid="default-units" className="flex flex-col gap-4">
      <h2 className="text-[14px] font-medium text-text-primary">Default Units</h2>

      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <span className="text-[13px] text-text-secondary">Weight Unit</span>
          <div data-testid="weight-unit-toggle" className="flex rounded-[4px] border border-border overflow-hidden">
            <button
              data-testid="weight-unit-lbs"
              onClick={() => toggleWeight('lbs')}
              className={`h-7 px-3 text-[13px] transition-colors duration-100 cursor-pointer ${
                weightUnit === 'lbs'
                  ? 'bg-accent text-white font-medium'
                  : 'bg-surface text-text-secondary hover:bg-hover'
              }`}
            >
              lbs
            </button>
            <button
              data-testid="weight-unit-kg"
              onClick={() => toggleWeight('kg')}
              className={`h-7 px-3 text-[13px] transition-colors duration-100 cursor-pointer ${
                weightUnit === 'kg'
                  ? 'bg-accent text-white font-medium'
                  : 'bg-surface text-text-secondary hover:bg-hover'
              }`}
            >
              kg
            </button>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-[13px] text-text-secondary">Temperature Unit</span>
          <div data-testid="temperature-unit-toggle" className="flex rounded-[4px] border border-border overflow-hidden">
            <button
              data-testid="temperature-unit-f"
              onClick={() => toggleTemperature('F')}
              className={`h-7 px-3 text-[13px] transition-colors duration-100 cursor-pointer ${
                temperatureUnit === 'F'
                  ? 'bg-accent text-white font-medium'
                  : 'bg-surface text-text-secondary hover:bg-hover'
              }`}
            >
              F
            </button>
            <button
              data-testid="temperature-unit-c"
              onClick={() => toggleTemperature('C')}
              className={`h-7 px-3 text-[13px] transition-colors duration-100 cursor-pointer ${
                temperatureUnit === 'C'
                  ? 'bg-accent text-white font-medium'
                  : 'bg-surface text-text-secondary hover:bg-hover'
              }`}
            >
              C
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
